import { createFileRoute } from '@tanstack/react-router'

import { PaymentOriginShareScreen } from './-components/payment-origin-share-screen.tsx'

export const Route = createFileRoute('/cs-tools/payment-origin-share')({
  component: PaymentOriginShareScreen
})
